import { useQuery } from "@tanstack/react-query";
import { ApiGetUserAutoTradeLossCompPool2Info } from "@/api";
import type { GetUserAutoTradeLossCompPool2InfoResponse } from "@/api/types";

/**
 * 获取用户自动交易亏损补偿池2汇总
 * 对应接口：`/game/cex/GetUserAutoTradeLossCompPool2Info`
 */
export function useGetUserAutoTradeLossCompPool2Info() {
  return useQuery({
    queryKey: ["userAutoTradeLossCompPool2Info"],
    queryFn: async (): Promise<GetUserAutoTradeLossCompPool2InfoResponse> => {
      const res = await ApiGetUserAutoTradeLossCompPool2Info({});
      console.log("ApiGetUserAutoTradeLossCompPool2Info", res);
      return res.data;
    },
  });
}
